<div class="body">
    <div class="nav-bar">
        <mat-icon *ngIf="icon" class="icon">{{icon}}</mat-icon>
        <span class="headline">{{headline}}</span>
        <mat-icon class="closer" (click)="cancel()">clear</mat-icon>
    </div>
    <div class="content">
        <div class="sub-title">{{subTitle}}</div>
        <div class="highlighted">{{highlighted}}</div>
        <mat-form-field class="input">
            <mat-label class="label">{{label}}</mat-label>
            <input matInput placeholder={{placeholder}} class="text-input" [(ngModel)]="value" (keyup.enter)="submit()">
        </mat-form-field>
        <div class="control-row">
            <button mat-button color="primary" (click)="submit()">{{buttonText}}</button>
        </div>
    </div>
</div>